import { cn } from '@/lib/utils';

interface StatusBadgeProps {
  status: 0 | 1 | 2;
  className?: string;
}

const statusConfig = {
  0: {
    label: '正常',
    className: 'bg-success/10 text-success border-success/25',
    dotClassName: 'bg-success shadow-[0_0_8px_hsl(var(--success)/0.6)]',
    pulse: true,
  },
  1: {
    label: '已封',
    className: 'bg-destructive/10 text-destructive border-destructive/25',
    dotClassName: 'bg-destructive',
    pulse: false,
  },
  2: {
    label: '已清零',
    className: 'bg-muted/40 text-muted-foreground border-border',
    dotClassName: 'bg-muted-foreground/40',
    pulse: false,
  },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <div
      className={cn(
        'inline-flex h-7 items-center gap-2 whitespace-nowrap rounded-md border px-2.5 text-[0.8125rem] font-semibold tracking-wide',
        config.className,
        className,
      )}
    >
      <span
        className={cn('size-2 rounded-full', config.dotClassName, config.pulse && 'animate-pulse')}
      />
      {config.label}
    </div>
  );
}
